<template>
  <div class="custom__toolbar d-flex mb-5">
    <v-spacer />
    <v-btn
      @click="$router.push('/users/create')"
      outlined
      depressed
      color="primary"
      tile
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      <span>
        ADD NEW
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss">
.session-toolbar {
  .v-toolbar__content {
    padding: 0px !important;
  }
}
</style>
